export default __webpack_public_path__ + "static/media/soul_thieves_3.1be04220.png";